import type { SectionsPropsType } from '../../sections/types';
import { tileRoofCrackSection } from './sections/tileRoofCrack';
import { tileRoofFadingSection } from './sections/tileRoofFading';
import { tileRoofLeakageSection } from './sections/tileRoofLeakage';
import { roofFadingSection } from './sections/roofFading';
import { roofMoldSection } from './sections/roofMold';
import { roofCrackSection } from './sections/roofCrack';
import { roofLeakageSection } from './sections/roofLeakage';
import { roofDeteriorationEvaluationSection } from './sections/roofDeteriorationEvaluation';

export const roofDeteriorationBundle = async (props: SectionsPropsType) => {
  const { userAnswers } = props;
  const roofingMaterialAnswer = userAnswers.find((answer) => answer.keyName === 'roofingMaterial');

  if (roofingMaterialAnswer.answer === '瓦') {
    // 劣化診断_瓦_色あせ
    await tileRoofFadingSection(props);

    // 劣化診断_瓦_ひび割れ
    await tileRoofCrackSection(props);

    // 劣化診断_瓦_雨漏り
    await tileRoofLeakageSection(props);
  } else {
    // 劣化診断_色あせ
    await roofFadingSection(props);

    // 劣化診断_カビ・コケ
    await roofMoldSection(props);

    // 劣化診断_ひび割れ
    await roofCrackSection(props);

    // 劣化診断_雨漏り
    await roofLeakageSection(props);
  }

  // 劣化診断_総評
  await roofDeteriorationEvaluationSection(props);
};
